import { RowData, Table } from "@tanstack/react-table";

import { Pagination, RowCountLabelVariant } from "../../Pagination";

interface TSTPaginationProps<T extends RowData> {
    table: Table<T>;
    pageLabel: string;
    getRowCountLabel:
        | ((pageSize: number, totalRowCount: number) => string)
        | null;
    getSinglePageRowCountLabel?: (totalRowCount: number) => string;
    showPageSizeSelect?: boolean;
    pageSizeOptions?: number[];
    tableElement?: React.RefObject<HTMLDivElement | null>;
    variant?: RowCountLabelVariant;
}
export function TSTPagination<T extends RowData>({
    table,
    pageLabel,
    getRowCountLabel,
    getSinglePageRowCountLabel,
    showPageSizeSelect,
    pageSizeOptions,
    tableElement,
    variant,
}: TSTPaginationProps<T>) {
    const paginationState = table.getState().pagination;
    const totalRowCount = table.getPrePaginationRowModel().rows.length;
    const noRows = totalRowCount === 0;

    if (noRows) {
        return null;
    }
    return (
        <Pagination
            tableElement={tableElement}
            pageSize={paginationState.pageSize}
            pageLabel={pageLabel}
            getRowCountLabel={getRowCountLabel}
            getSinglePageRowCountLabel={getSinglePageRowCountLabel}
            onPageSizeChange={(size) => {
                table.setPageSize(size);
            }}
            current={paginationState.pageIndex}
            onChangePage={(page) => {
                table.setPageIndex(page);
            }}
            total={table.getPageCount()}
            totalRowCount={totalRowCount}
            showPageSizeSelect={showPageSizeSelect}
            pageSizeOptions={pageSizeOptions}
            variant={variant}
        />
    );
}
